import {Action, handleActions} from "redux-actions";
import {none, option} from "ts-option";
import {JobStatusState} from "./JobStatusState";
import {
	JOB_STATUS_CREATED,
	JOB_STATUS_EDITED,
	JOB_STATUS_SORT_ORDER_UPDATED,
	JOB_STATUS_SUSPEND_UPDATED,
	JOB_STATUSES_FETCHED,
	JOB_WARRANTY_REGISTRATION_STATUSES_FETCHED,
} from "../../action/jobStatus/actionType";

const initState: JobStatusState = {
	jobStatuses: none,
	jobWarrantyRegistrationStatuses: none
};

const reducer = handleActions({
	[JOB_STATUSES_FETCHED]: (state: JobStatusState,
		action: Action<any>): JobStatusState => {
		return {...state, jobStatuses: option(action.payload.jobStatuses)}
	},
	[JOB_STATUS_CREATED]: (state: JobStatusState,
		action: Action<JOB_STATUS_CREATED>): JobStatusState => {
		return {
			...state,
			jobStatuses: option(state.jobStatuses.getOrElse([]).concat(action.payload.jobStatus))
		}
	},
	[JOB_STATUS_EDITED]: (state: JobStatusState,
		action: Action<JOB_STATUS_EDITED>): JobStatusState => {
		const jobStatuses = state.jobStatuses.getOrElse([]).map(
			s => s.id == action.payload.jobStatus.id ? action.payload.jobStatus : s);
		return {...state, jobStatuses: option(jobStatuses)}
	},
	[JOB_STATUS_SORT_ORDER_UPDATED]: (state: JobStatusState,
		action: Action<JOB_STATUS_SORT_ORDER_UPDATED>): JobStatusState => {
		return {...state, jobStatuses: option(action.payload.jobStatuses)};
	},
	[JOB_WARRANTY_REGISTRATION_STATUSES_FETCHED]: (state: JobStatusState,
		action: Action<JOB_WARRANTY_REGISTRATION_STATUSES_FETCHED>): JobStatusState => {
		return {...state, jobWarrantyRegistrationStatuses: option(action.payload.jobWarrantyRegistrationStatuses)};
	},
	[JOB_STATUS_SUSPEND_UPDATED]: (state: JobStatusState, action: Action<JOB_STATUS_SUSPEND_UPDATED>): JobStatusState => {
		const jobStatuses = state.jobStatuses.getOrElse([]).map(
			s => s.id == action.payload.jobStatusId ? s.copy({disabled: action.payload.disabled}) : s);
		return {...state, jobStatuses: option(jobStatuses)}
	}
}, initState);

export default reducer;
